export const temperamentQuestions = [
  {
    number: 1,
    question: 'At a party do you...',
    answers: [
      'interact with many, including strangers?',
      'interact with a few, known to you?',
    ],
  },
  {
    number: 2,
    question: 'Are you more...',
    answers: ['realistic than speculative?', 'speculative than realistic?'],
  },
  {
    number: 3,
    question: 'Is it worse to...',
    answers: ['have your "head in the clouds"?', 'be "in a rut"?'],
  },
  {
    number: 4,
    question: 'Are you more impressed by...',
    answers: ['principles?', 'gut emotions?'],
  },
  {
    number: 5,
    question: 'Are you more drawn toward the...',
    answers: ['convincing?', 'touching?'],
  },
  {
    number: 6,
    question: 'Do you prefer to work...',
    answers: ['to deadlines?', 'just "whenever"?'],
  },
  {
    number: 7,
    question: 'Do you tend to choose...',
    answers: ['rather carefully?', 'somewhat impulsively?'],
  },
  {
    number: 8,
    question: 'At parties do you...',
    answers: [
      'stay late, with increasing energy?',
      'leave early, with decreased energy?',
    ],
  },
  {
    number: 9,
    question: 'Are you more attracted to...',
    answers: ['sensible people?', 'imaginative people?'],
  },
  {
    number: 10,
    question: 'Are you more interested in...',
    answers: ['what is actual?', 'what is possible?'],
  },
  {
    number: 11,
    question: 'In judging others are you more swayed by...',
    answers: ['laws than circumstances?', 'circumstances than laws?'],
  },
  {
    number: 12,
    question: 'In approaching others is your inclination to be somewhat...',
    answers: ['objective (detached)?', 'personal?'],
  },
  {
    number: 13,
    question: 'Are you more...',
    answers: ['punctual?', 'leisurely?'],
  },
  {
    number: 14,
    question: 'Does it bother you more having things...',
    answers: ['incomplete?', 'completed?'],
  },
  {
    number: 15,
    question: 'In your social groups do you...',
    answers: ["keep abreast of other's happenings?", 'get behind on news?'],
  },
  {
    number: 16,
    question: 'In doing ordinary things are you more likely to...',
    answers: ['do it the usual way?', 'do it your own way?'],
  },
  {
    number: 17,
    question: 'Writers should...',
    answers: [
      '"say what they mean and mean what they say"?',
      'express things more by use of analogy?',
    ],
  },
  {
    number: 18,
    question: 'Which appeals to you more?',
    answers: ['Consistency of thought', 'Harmonious human relationships'],
  },
  {
    number: 19,
    question: 'Are you more comfortable in making...',
    answers: ['logical judgements?', 'value judgements?'],
  },
  {
    number: 20,
    question: 'Do you want things...',
    answers: ['settled and decided?', 'unsettled and undecided?'],
  },
  {
    number: 21,
    question: 'Would you say you are more...',
    answers: ['serious and detemined?', 'easy-going?'],
  },
  {
    number: 22,
    question: 'Before making a phone call, do you...',
    answers: [
      'rarely question that it will all be said?',
      "rehearse what you'll say?",
    ],
  },
  {
    number: 23,
    question: 'Facts...',
    answers: ['speak for themselves', 'illustrate principles'],
  },
  {
    number: 24,
    question: 'Are visionaries...',
    answers: ['somewhat annoying?', 'rather fascinating?'],
  },
  {
    number: 25,
    question: 'Are you more often...',
    answers: ['a cool-headed person?', 'a warm-hearted person?'],
  },
  {
    number: 26,
    question: 'It is worse to be...',
    answers: ['unjust?', 'merciless?'],
  },
  {
    number: 27,
    question: 'Should one usually let events occur...',
    answers: ['by careful selection and choice?', 'randomly and by chance?'],
  },
  {
    number: 28,
    question: 'Do you feel better about...',
    answers: ['having purchased?', 'having the option to buy?'],
  },
  {
    number: 29,
    question: 'In company do you...',
    answers: ['initiate conversation?', 'wait to be approached?'],
  },
  {
    number: 30,
    question: 'Common sense is...',
    answers: ['rarely questionable?', 'frequently questionable?'],
  },
  {
    number: 31,
    question: 'Children often do not...',
    answers: [
      'make themselves useful enough?',
      'exercise their fantasy enough?',
    ],
  },
  {
    number: 32,
    question: 'In making decisions do you feel more comfortable with...',
    answers: ['standards?', 'feelings?'],
  },
  {
    number: 33,
    question: 'Are you more...',
    answers: ['firm than gentle?', 'gentle than firm?'],
  },
  {
    number: 34,
    question: 'Which is more admirable...',
    answers: [
      'the ability to organise and be methodical?',
      'the ability to adapt and make do?',
    ],
  },
  {
    number: 35,
    question: 'Do you put more value on the...',
    answers: ['definite?', 'open-ended?'],
  },
  {
    number: 36,
    question: 'Does new and non-routine interaction with others...',
    answers: ['stimulate and energise you?', 'tax your reserves?'],
  },
  {
    number: 37,
    question: 'Are you more frequently...',
    answers: ['a practical sort of person?', 'a fanciful sort of person?'],
  },
  {
    number: 38,
    question: 'Are you more likey to...',
    answers: ['see how others are useful?', "see how other's see?"],
  },
  {
    number: 39,
    question: 'Which is more satisfying...',
    answers: [
      'to discuss an issue thoroughly?',
      'to arrive at agreement on an issue?',
    ],
  },
  {
    number: 40,
    question: 'Which rules you more?',
    answers: ['Your head', 'Your heart'],
  },
  {
    number: 41,
    question: 'Are you more comfortable with work that is...',
    answers: ['contracted?', 'done on a casual basis?'],
  },
  {
    number: 42,
    question: 'Do you tend to look for...',
    answers: ['the orderly?', 'whatever turns up?'],
  },
  {
    number: 43,
    question: 'Do you prefer...',
    answers: [
      'many friends with brief contact?',
      'a few friends with more lengthy contact?',
    ],
  },
  {
    number: 44,
    question: 'Do you go more by...',
    answers: ['facts?', 'principles?'],
  },
  {
    number: 45,
    question: 'Are you more interested in...',
    answers: ['production and distribution?', 'design and research?'],
  },
  {
    number: 46,
    question: 'Which is more of a compliment?',
    answers: [
      '"You are a very logical person."',
      '"You are a very sentimental person."',
    ],
  },
  {
    number: 47,
    question: 'Do you value in yourself more that you are...',
    answers: ['unwavering?', 'devoted?'],
  },
  {
    number: 48,
    question: 'Do you more often prefer the...',
    answers: [
      'final and unalterable statement?',
      'tentative and preliminary statement?',
    ],
  },
  {
    number: 49,
    question: 'Are you more comfortable...',
    answers: ['after a decision?', 'before a decision?'],
  },
  {
    number: 50,
    question: 'Do you...',
    answers: [
      'speak easily and at length with strangers?',
      'find little to say to strangers?',
    ],
  },
  {
    number: 51,
    question: 'Are you more likely to trust your...',
    answers: ['experience?', 'hunch?'],
  },
  {
    number: 52,
    question: 'Do you feel...',
    answers: [
      'more practical than ingenious?',
      'more ingenious than practical?',
    ],
  },
  {
    number: 53,
    question: 'Which person is more to be complimented, one of...',
    answers: ['clear reason?', 'strong feeling?'],
  },
  {
    number: 54,
    question: 'Are you inclined more to be...',
    answers: ['fair minded?', 'sympathetic?'],
  },
  {
    number: 55,
    question: 'Is it preferable mostly to...',
    answers: ['make sure things are arranged?', 'just let things happen?'],
  },
  {
    number: 56,
    question: 'In relationships should most things be...',
    answers: ['renegotiable?', 'random and circumstantial?'],
  },
  {
    number: 57,
    question: 'When the phone rings do you...',
    answers: ['hasten to get to it first?', 'hope somebody else will answer?'],
  },
  {
    number: 58,
    question: 'Do you prize more in yourself...',
    answers: ['a strong sense of reality?', 'a vivid imagination?'],
  },
  {
    number: 59,
    question: 'Are you drawn more to...',
    answers: ['fundamentals?', 'overtones?'],
  },
  {
    number: 60,
    question: 'Which seems the greater error...',
    answers: ['to be too passionate?', 'to be too objective?'],
  },
  {
    number: 61,
    question: 'Do you see yourself as basically...',
    answers: ['hard-headed?', 'soft-hearted?'],
  },
  {
    number: 62,
    question: 'Which situation appeals to you more...',
    answers: [
      'the structured and the scheduled?',
      'the unstructured and unscheduled?',
    ],
  },
  {
    number: 63,
    question: 'Are you a person that is more...',
    answers: ['routinized than whimsical?', 'whimsical than routinized?'],
  },
  {
    number: 64,
    question: 'Are you more inclined to be...',
    answers: ['easy to approach?', 'somewhat reserved?'],
  },
  {
    number: 65,
    question: 'In writings do you prefer...',
    answers: ['the more literal?', 'the more figurative?'],
  },
  {
    number: 66,
    question: 'Is it harder for you to...',
    answers: ['identify with others?', 'utilise others?'],
  },
  {
    number: 67,
    question: 'Which do you wish more for yourself?',
    answers: ['Clarity of reason', 'Strength of compassion'],
  },
  {
    number: 68,
    question: 'Which is the greater fault?',
    answers: ['Being indiscriminate', 'Being critical'],
  },
  {
    number: 69,
    question: 'Do you prefer the...',
    answers: ['planned event?', 'unplanned event?'],
  },
  {
    number: 70,
    question: 'Do you tend to be more...',
    answers: ['deliberate than spontaneous?', 'spontaneous than deliberate?'],
  },
];

export const selfPerceptionContent = [
  {
    name: 'selfEI',
    choices: ['Extroversion', 'Introversion'],
    details: [
      'Like variety and action. Often impatient with long, slow tasks. Often act quickly, sometimes without thinking. Develop ideas by mutual discussion',
      'Like quiet for concentration. Tend not to mind long, slow tasks. Like to think before they act. Develop ideas by reflection.',
    ],
  },
  {
    name: 'selfSN',
    choices: ['Sensing', 'Intuition'],
    details: [
      'Like using experience and standard ways to solve problems. May distrust and ignore their inspirations. Enjoy using developed skills. Seldom make errors of fact. Prefer communication of what is.',
      'Like solving new and complex problems. May follow inspirations, good or bad. Like to do innovative things. Enjoy learning new skills. Frequently make errors of fact. Prefer change, sometimes radical.',
    ],
  },
  {
    name: 'selfTF',
    choices: ['Thinking', 'Feeling'],
    details: [
      "Use loigical analysis to reach conclusions. Can work without harmony. May hurt people's feelings without knowing it. Tend to decide impersonally, sometimes paying insufficient attention to people's wishes. Tend to be firm minded and can give criticism when appropriate. Looks at the principles involved in a situation.",
      'Uses values to reach conclusions. Works best in harmony with others. Enjoy pleasing people, even in unimportant things. Often lets decisions be influenced by their own and other peoples likes and dislikes. Tend to be sympathetic and dislike, even avoid, telling other people things. Look at the underlying issues in a situation. ',
    ],
  },
  {
    name: 'selfJP',
    choices: ['Judging', 'Perceiving'],
    details: [
      'Work best when they can make and follow a plan. Like to get things settled and finished. Tend to be satisfied upon reaching decisions. Reach closure by deciding quickly. Seek structure and schedules. Tend to be punctual.',
      'Enjoy flexibility in their work. Like to leave things open for minute changes. Tend to be curious and like new angles. Postpone decisions, waiting for options. Adapt well to changing situations and feel restricted without change. Tend not to mind being late.',
    ],
  },
];

export const questionGroups = {
  EI: [ 1, 8, 15, 22, 29, 36, 43, 50, 57, 64 ],
  SN: [ 2, 3, 9, 10, 16, 17, 23, 24, 30, 31, 37, 38, 44, 45, 51, 52, 58, 59, 65, 66 ],
  TF: [ 4, 5, 11, 12, 18, 19, 25, 26, 32, 33, 39, 40, 46, 47, 53, 54, 60, 61, 67, 68 ],
  JP: [ 6, 7, 13, 14, 20, 21, 27, 28, 34, 35, 41, 42, 48, 49, 55, 56, 62, 63, 69, 70 ]
};

export const dummyData = {selfEI: 2,
  selfSN: 3,
  selfTF: 1,
  selfJP:2, name: "Ruairidh Flint", 1: "a", 2: "b", 3: "a", 4: "b", 5: "a", 6: "b", 7: "a", 8: "b", 9: "a", 10: "b", 11: "a", 12: "b", 13: "a", 14: "b", 15: "a", 16: "b", 17: "a", 18: "a", 19: "b", 20: "a", 21: "a", 22: "b", 23: "a", 24: "b", 25: "a", 26: "a", 27: "b", 28: "b", 29: "b", 30: "b", 31: "a", 32: "a", 33: "a", 34: "a", 35: "b", 36: "a", 37: "b", 38: "a", 39: "b", 40: "a", 41: "b", 42: "a", 43: "b", 44: "b", 45: "b", 46: "a", 47: "a", 48: "a", 49: "b", 50: "b", 51: "b", 52: "a", 53: "a", 54: "b", 55: "a", 56: "b", 57: "a", 58: "b", 59: "a", 60: "b", 61: "a", 62: "b", 63: "a", 64: "b", 65: "a", 66: "b", 67: "b", 68: "b", 69: "a", 70: "a"}

